import { clsx } from 'clsx'
import { Glyph, type GlyphName } from './glyphs'
import { R5Link } from './R5Link'

export interface NavPillProps {
  to: string
  /** Translated label. */
  label: string
  glyph: GlyphName
  active: boolean
  /** `top` is the glyph-and-label pill of the top bar; `bottom` is the glyph-over-label slot of the floating phone bar. */
  placement?: 'top' | 'bottom'
}

/**
 * One primary destination (APP-DESIGN-DIRECTION 4.1). A router link (`R5Link`, lateral route move) styled as a pill: the rest
 * glyph and an ink-2 label; the current destination swaps to the filled glyph (which pops) and a navy label, with
 * `aria-current="page"`. The fill behind it is the bar's shared indicator, so it stretches between items.
 */
export function NavPill({ to, label, glyph, active, placement = 'top' }: NavPillProps) {
  return (
    <R5Link to={to} transition="lateral" className={clsx('r5-nav__item', placement === 'bottom' && 'r5-nav__item--bottom', active && 'r5-nav__item--active')} aria-current={active ? 'page' : undefined}>
      <Glyph name={glyph} state={active ? 'active' : 'rest'} size={placement === 'bottom' ? 24 : 20} />
      <span data-text={label}>{label}</span>
    </R5Link>
  )
}
